import { mergePageVars } from "../../contract/document.js";
import { createSpriteSheet } from "../../dom/paint.js";
import { buildFrameShell, PAGE_FRAMES } from "../../dom/canvas.js";
import { renderPageFrame } from "../../preview/compose.js";

/** @param {import("../viewer-deps.js").ViewerDeps} deps */
export function createPageStage(deps) {
  function paintPage() {
    const doc = deps.getDoc();
    if (!doc) return;
    const started = performance.now();
    const theme = deps.getTheme();
    const pageKey = deps.activePageKey();
    const vars = mergePageVars(doc, theme, pageKey);
    const onAction = deps.createPreviewOnAction(vars);
    deps.pageCanvas.spriteHost.replaceChildren(createSpriteSheet());
    const row = deps.pageCanvas.row;
    row.replaceChildren();

    let nextId = 1;
    const allErrors = [];
    let totalCount = 0;
    for (const spec of PAGE_FRAMES) {
      const result = renderPageFrame(doc, {
        theme,
        viewportWidth: spec.width,
        pageKey,
        onAction,
        nextIdStart: nextId,
        ...deps.previewSlotOptions(),
        phaseByWidget: deps.previewPhaseByWidget(),
        adminImageBaseUrl: deps.getAdminImageBaseUrl?.() || "",
      });
      nextId = result.nextId;
      totalCount += result.count;
      allErrors.push(...result.elementErrors);
      row.append(buildFrameShell(spec, result.el));
    }

    if (allErrors.length) {
      deps.errorBox.hidden = false;
      deps.errorBox.textContent = allErrors.join("; ");
    } else {
      deps.errorBox.hidden = true;
    }

    requestAnimationFrame(() => deps.pageCanvas.resetToBaseline());
    const metaItems = [
      deps.metaItem(`Theme: ${theme}`),
      deps.metaItem(`Page: ${pageKey}`),
      deps.metaItem(`Frames: ${PAGE_FRAMES.length}`),
      deps.metaItem(`Components: ${totalCount}`),
      deps.metaItem(`Time to render: ${(performance.now() - started).toFixed(1)}ms`),
    ];
    const ref = doc.reference;
    if (ref?.url) metaItems.push(deps.metaItem(`Reference: ${ref.url}`));
    if (ref?.session) metaItems.push(deps.metaItem(`Session: ${ref.session}`));
    deps.pageMeta.replaceChildren(...metaItems);
  }

  return { paintPage };
}
